<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Stok Gudang</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="input.tanggal" name="filterTable"
                            id="filterInput"
                            type="date"
                        ></b-form-input>
                        <b-form-input class="mr-2"
                            v-model="input.filterNamaCabang" name="filterNamaCabang"
                            type="search"
                            id="filterNamaCabang"
                            placeholder="Masukkan nama cabang"
                        ></b-form-input>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter(filter)"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="pgiBtn" name="cekStokBtn" @click="openCekStokModal">Cek Stok Sekarang</b-button>
            </div>
            <b-table bordered hover show-empty sticky-header :style="`max-height: ${window.tableHeight}`"
                :busy="isBusy"
                :items="stokGudang" 
                :fields="fields"
                responsive class="mb-0">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data stok gudang.
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <a v-bind:href="$baseFilePath + row.item.name2" download>
                            <i class="fa fa-download mr-2"></i>
                            Buka File
                        </a>
                    </div>
                </template>
            </b-table>
        </b-card>
        <b-modal id="modal-cekstok-sekarang" title="Cek Stok Sekarang" hide-footer no-close-on-backdrop>
            <form id="cekStokSekarangForm" @submit.prevent="onCekStokSekarang" class="cek-stok-form">
                <b-form-group label="Cabang">
                    <div class="d-flex align-items-center">
                        <multiselect class="mr-2"
                            name="cabang"
                            v-model="input.cekStokCabang" 
                            :options="cekStokCabangOption" 
                            :internal-search="true"
                            :allow-empty="false"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="name"
                            placeholder="Cabang"
                        />
                        <b-button class="mr-2 cek-stok-btn" variant="pgiBtn" name="cekStokSekarangBtn" type="submit" :disabled="isLoading" form="cekStokSekarangForm">
                            <b-spinner small type="grow" v-if="isLoading"></b-spinner>
                            <i class="fa fa-search mr-1" v-else></i>
                            {{isLoading ? 'Memproses' : 'Cek Stok'}}
                        </b-button>
                    </div>
                </b-form-group>
                <div class="show-btn-download" v-if="showDownloadBtn">
                    <div v-if="isLoading">
                        <div class="text-center">
                            <b-spinner class="align-middle mb-4"></b-spinner>
                            <p class="mb-0">Sedang memproses, mohon menunggu...</p>
                        </div>
                    </div>
                    <div v-else>
                        <p class="text-muted smallText mb-1">
                            * Silahkan klik tombol dibawah ini untuk download Excel stok gudang {{activeCekStokCabang}}
                        </p>
                        <b-button variant="pgiBtn" class="mb-0 download-btn">
                            <a v-bind:href="$baseFilePath + filePathCekStok" download>
                                <i class="fa fa-download mr-2"></i>
                                Download File Stok
                            </a>
                        </b-button>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'stok-gudang',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isLoading: false,
            input:{
                tanggal: "",
                filterNamaCabang: null,
                cekStokCabang: null
            },
            cekStokCabangOption: [],
            activeInputTanggal : "",
            fields: [
                { key: "name", label: "Nama Cabang", sortable:true},
                { key: "name3", label: "Kode Cabang", sortable:true},
                { key: "action", label: "Aksi"}
            ],
            filter: null,
            stokGudangAll: [],
            stokGudang: [],
            stokGudangOld: [],
            window: {
                tableHeight: 0,
            },
            activeCekStokCabang: "",
            filePathCekStok: "",
            query: "",
            showDownloadBtn: false,
            userRole: localStorage.getItem("role"),
        }
    }, 
    
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 1

            let today = new Date();
            let dd = today.getDate();

            let mm = today.getMonth()+1; 
            let yyyy = today.getFullYear();

            if(dd<10) 
            {
                dd='0'+dd;
            } 

            if(mm<10) 
            {
                mm='0'+mm;
            } 

            let date = yyyy+'-'+mm+'-'+dd;

            this.input.tanggal = date
            this.activeInputTanggal = date

            this.query = "?tanggal=" + this.input.tanggal
            let getStokGudang = this.$axios.get("laporan-stok/histori/"+this.query).then(response => {
                this.stokGudangAll = response.data
                this.stokGudang = response.data
                this.stokGudangOld = response.data
        
            })

            let getCabangSelectionOption = this.checkCabangOption()

            Promise.all([getStokGudang, getCabangSelectionOption]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
              
                if(error == 'Error: Request failed with status code 500'){
                    this.initStatus = 1
                    this.toggleBusy()
                    this.stokGudangAll = []
                    this.stokGudangOld = []
                    this.stokGudang = []
                }else{
                    console.log(error)
                    this.initStatus = -1
                }
            })
        },

        checkCabangOption(){
            this.$axios.get("laporan-stok/allowed-cabang").then(response => {
                if(response.data.length == 0){
                    let getCabangSelectionOption = localStorage.getItem("cabang")
                    this.cekStokCabangOption = JSON.parse(getCabangSelectionOption)
                }else{
                    this.cekStokCabangOption = response.data
                }
            })

        },

        getNewStokGudang(){
            this.toggleBusy()
            this.stokGudang = []
            this.query = "?tanggal=" + this.input.tanggal
            if(this.input.tanggal == this.activeInputTanggal){
                if(this.input.filterNamaCabang != null){
                    let arrayCopy = [...this.stokGudangAll]
                    let menuFilter = arrayCopy.filter(item => item.name.toLowerCase().includes(this.input.filterNamaCabang.toLowerCase()) || item.name3.toLowerCase().includes(this.input.filterNamaCabang.toLowerCase()))
                    this.stokGudang = menuFilter  
                    this.toggleBusy() 
                }else{
                    this.getStokGudang()
                }
            } else {
                this.$axios.get("laporan-stok/histori/"+this.query).then(response => {
                    this.stokGudangAll = response.data
                    this.activeInputTanggal = this.input.tanggal
                    if (this.input.filterNamaCabang != null){
                        let arrayCopy = [...response.data]
                        let menuFilter = arrayCopy.filter(item => item.name.toLowerCase().includes(this.input.filterNamaCabang.toLowerCase())  || item.name3.toLowerCase().includes(this.input.filterNamaCabang.toLowerCase()))
                        this.stokGudang = menuFilter  
                        this.toggleBusy() 
                    }else{
                        this.stokGudang = response.data
                        this.toggleBusy() 
                    }
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                })
            }
        },

        //-----------------  Fungsi Ambil Data stokGudang ----------------- 
        
        getStokGudang(){
            this.stokGudang = this.stokGudangOld
            this.toggleBusy()
        },

        onFilter(){

            if(!this.$helper.isNotNullAndNotEmpty(this.input.tanggal)){
                this.$helper.toastErr(this, "Mohon isi tanggal!")
            }else{
                this.getNewStokGudang()
            }

        },

        onReset(){
            let today = new Date();
            let dd = today.getDate();

            let mm = today.getMonth()+1; 
            let yyyy = today.getFullYear();

            if(dd<10) 
            {
                dd='0'+dd;
            } 

            if(mm<10) 
            {
                mm='0'+mm;
            } 

            let date = yyyy+'-'+mm+'-'+dd;
            this.input.tanggal = date
            this.activeInputTanggal = date
            this.input.filterNamaCabang = null
            this.toggleBusy()
            this.getStokGudang()
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy(){
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        handleResize() {
            let windowHeight = window.innerHeight
            let tableHeight = windowHeight - (55+46+50+82+51+48)
            this.window.tableHeight = tableHeight+'px'
        },

        openCekStokModal(){
            this.$bvModal.show("modal-cekstok-sekarang")
        },

        onCekStokSekarang(){
            if(this.input.cekStokCabang != null){
                this.query = "?cabangId="+this.input.cekStokCabang.id
                //----------------- Submit Semua Data -----------------

                this.isLoading = true
                this.showDownloadBtn = true
          
                this.$axios.get("laporan-stok/"+this.query).then(response => {
                    let dataCabang = [...this.cekStokCabangOption]
                    let getNameCabang = dataCabang.filter(item=> item.id == this.input.cekStokCabang.id)
                    this.activeCekStokCabang = getNameCabang[0].name
                    this.filePathCekStok = response.data.name
                  
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isLoading = false
                })
            }else{
                this.$helper.toastErr(this, "Silakan pilih cabang yang diingin di cek terlebih dahulu!")
            }
        },

    },
    created(){
        this.init()
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }
}
</script>
